import { FetchAuth } from "../utils/FetchAuthUtil";

const endpoint = process.env.REACT_APP_API_ENDPOINT;

export interface FAQResponse {
    faqs: FAQdto[];
    total: number;
    page: number;
    limit: number;
    totalPages: number;
}

export interface FAQdto {
    title: {
        ar: string;
        fr: string;
        eng: string;
    };
    answer: {
        ar: string;
        fr: string;
        eng: string;
    };
    _id: string;
    createdDate: string;
}
    

export class FAQService {

    public static createFAQ = async (titles: { eng: string, fr: string, ar: string }, answers: { eng: string, fr: string, ar: string }): Promise<any> => {
        try {
            const resp = await FetchAuth(endpoint + `/faq/create`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ 
                    title: titles,
                    answer: answers
                }),
            });

            const data = await resp.json();
            return data;
        } catch (error) {
            throw error;
        }
    }

    public static getFAQs = async (currentPage: number, pageSize: number, searchTerm: string, sortColumn: string, sortDirection: string): Promise<FAQResponse> => {
        const params = new URLSearchParams();
        params.append('currentPage', currentPage.toString());
        params.append('pageSize', pageSize.toString());
        params.append('searchTerm', searchTerm);
        params.append('sortColumn', sortColumn);
        params.append('sortDirection', sortDirection);
        
        try {
            const resp = await FetchAuth(endpoint + `/faq/getFAQs?${params.toString()}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            });

            const data = await resp.json();
            return data;
        } catch (error) {
            throw error;
        }
    }

    public static deleteFAQ = async (id: string): Promise<FAQResponse> => {
        try {
            const resp = await FetchAuth(endpoint + `/faq/delete/${id}`, {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                },
            });

            const data = await resp.json();
            return data;
        } catch (error) {
            throw error;
        }
    }

    public static updateFAQ = async (id: string, titles: { eng: string, fr: string, ar: string }, answers: { eng: string, fr: string, ar: string }): Promise<any> => {
        try {
            const resp = await FetchAuth(endpoint + `/faq/update/${id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ 
                    title: titles,
                    answer: answers
                }),
            });

            const data = await resp.json();
            return data;
        } catch (error) {
            throw error;
        }
    }

    public static getExcelFile = async (): Promise<Blob> => {
        try {
            const resp = await FetchAuth(endpoint + `/faq/exportFAQsExcel`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",     
                },
            });

            return await resp.blob();
        } catch (error) {
            throw error;
        }
    }

    public static getCSVFile = async (): Promise<Blob> => {
        try {
            const resp = await FetchAuth(endpoint + `/faq/exportFAQsCSV`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            });

            return await resp.blob();
        } catch (error) {
            throw error;
        }
    }

    public static getPDFFile = async (): Promise<Blob> => {
        try {
            const resp = await FetchAuth(endpoint + `/faq/exportFAQsPDF`, {    
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            });

            return await resp.blob();
        } catch (error) {
            throw error;
        }
    }
}